function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import Vue from "vue";
import _ from "lodash";
import { checkAdvertiserIsExist } from "@/api/advertiser/manage";
import { accountTypeList, currencyList, isPrePayList, mwsAccountTypeList } from "@/views/advertiser/utils";
// ss 使用 yiminghe async-validator 邮箱校验正则修改
// eslint-disable-next-line
var emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default Vue.extend({
    data: function data() {
        return {
            formConfig: {
                labelWidth: "165px"
            }
        };
    },
    computed: {
        advertiser: function advertiser() {
            return this.$store.state.advertiser;
        },
        model: function model() {
            return this.$store.state.advertiser.info;
        },
        countryList: function countryList() {
            return this.$store.state.config.countryList;
        },
        timeZoneList: function timeZoneList() {
            return this.$store.state.config.timeZoneList;
        },
        isCreate: function isCreate() {
            return this.advertiser.type === "add";
        },
        submitButton: function submitButton() {
            return {
                type: "primary",
                loading: this.advertiser.loading
            };
        },
        schema: function schema() {
            var _this = this;
            var validatePassword = function(rule, value, callback) {
                if (!rule.required) callback();
                var regular = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,20}$/;
                var reg = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~\uFF01@#\uFFE5\u2026\u2026&*\uFF08\uFF09\u2014\u2014|{}\u3010\u3011\u2018\uFF1B\uFF1A\u201D\u201C'\u3002\uFF0C\u3001\uFF1F]") // 检查特殊符号
                ;
                if (_this.advertiser.exists === 2) {
                    callback();
                } else if (value.trim() === "") {
                    callback(new Error("\u8BF7\u8F93\u5165\u5BC6\u7801"));
                } else if (reg.test(value)) {
                    callback(new Error("\u5BC6\u7801\u4E0D\u80FD\u5305\u542B\u7279\u6B8A\u5B57\u7B26"));
                } else if (!regular.test(value)) {
                    callback(new Error("\u5BC6\u7801\u5FC5\u987B\u4E3A8-20\u4F4D\u4E14\u5305\u542B\u82F1\u6587\u5927\u5C0F\u5199\u548C\u6570\u5B57"));
                } else {
                    callback();
                }
            };
            var validateUsername = function(rule, value, callback) {
                var regular = /^[a-zA-Z][a-zA-Z0-9_.]{2,31}$/;
                var isStartWithLetter = /^[a-zA-Z]/;
                if (value.trim() === "") {
                    callback(new Error("\u8BF7\u8F93\u5165\u5E7F\u544A\u4E3B\u540D\u79F0"));
                } else if (!isStartWithLetter.test(value)) {
                    callback(new Error("\u5E7F\u544A\u4E3B\u540D\u79F0\u5FC5\u987B\u4EE5\u5B57\u6BCD\u5F00\u5934"));
                } else if (!regular.test(value)) {
                    callback(new Error("\u4EC5\u53EF\u8F93\u5165\u5B57\u6BCD\u3001\u6570\u5B57\u3001\u4E0B\u5212\u7EBF\uFF08\u4E0D\u652F\u6301\u8F93\u5165\u7A7A\u683C\uFF09,\u957F\u5EA6\u4E3A3-32\u4E2A\u5B57\u7B26"));
                } else {
                    var params = {
                        type: "name",
                        value: value
                    };
                    if (!_this.isCreate && _this.advertiser.info.id) {
                        params.id = _this.advertiser.info.id;
                    }
                    // 返回的广告主与输入的广告主相同则不校验
                    if (_this.advertiser.advertiser_name !== value) {
                        checkAdvertiserIsExist(params).then(function(res) {
                            if (Number(res.data.data.exists) === 1) {
                                callback(new Error("\u540D\u79F0\u5DF2\u5B58\u5728\uFF0C\u8BF7\u4FEE\u6539"));
                            } else {
                                callback();
                            }
                        });
                    } else {
                        callback();
                    }
                }
            };
            var validateEmail = function(rule, value, callback) {
                var regular = /^[^\s]*$/;
                if (value.trim() === "") {
                    callback(new Error("\u8BF7\u8F93\u5165\u5E7F\u544A\u4E3B\u90AE\u7BB1"));
                } else if (!regular.test(value)) {
                    callback(new Error("\u4E0D\u652F\u6301\u8F93\u5165\u7A7A\u683C"));
                } else if (!emailReg.test(value)) {
                    callback(new Error("\u8BF7\u8F93\u5165\u6B63\u786E\u683C\u5F0F\u90AE\u7BB1"));
                } else {
                    var params = {
                        type: "email",
                        value: value
                    };
                    if (!_this.isCreate && _this.advertiser.info.id) {
                        params.id = _this.advertiser.info.id;
                    }
                    // 返回的邮箱与输入的邮箱相同则不校验
                    if (_this.advertiser.advertiser_email !== value) {
                        checkAdvertiserIsExist(params).then(function(res) {
                            if (Number(res.data.data.exists) === 1) {
                                callback(new Error("\u90AE\u7BB1\u5DF2\u5B58\u5728\uFF0C\u8BF7\u4FEE\u6539"));
                            } else {
                                callback();
                            }
                        });
                    } else {
                        callback();
                    }
                }
            };
            var validateCCEmail = function(rule, value, callback) {
                var emails = _this.cookCCEmail();
                if (emails.length > 10) {
                    callback(new Error("\u6700\u591A\u53EF\u6DFB\u52A010\u4E2Acc email"));
                }
                for(var i in emails){
                    var _i;
                    var email = (_i = emails[i]) !== null && _i !== void 0 ? _i : "";
                    if (!emailReg.test(email)) {
                        callback(new Error("\u8BF7\u8F93\u5165\u6B63\u786E\u683C\u5F0F\u90AE\u7BB1"));
                    }
                }
                callback();
            };
            var validateInvoiceName = function(rule, value, callback) {
                if (value && _this.advertiser.info.invoices.filter(function(item) {
                    return item.name === value;
                }).length > 1) {
                    callback(new Error("Invoice Name \u4E0D\u53EF\u91CD\u590D"));
                }
                callback();
            };
            var cookInvoiceFormItem = function() {
                return _this.model.invoices.map(function(item) {
                    return {
                        type: "object",
                        disabled: !!item.readonly,
                        properties: {
                            name: {
                                label: "Invoice Name",
                                component: "input",
                                rules: [
                                    {
                                        required: true,
                                        trigger: "blur",
                                        message: "\u8BF7\u586B\u5199 Invoice Name"
                                    },
                                    {
                                        required: true,
                                        validator: validateInvoiceName,
                                        trigger: "blur"
                                    }, 
                                ]
                            },
                            company: {
                                label: "Name Of Business",
                                component: "input",
                                rules: [
                                    {
                                        required: true,
                                        trigger: "blur",
                                        message: "\u8BF7\u586B\u5199 Name Of Business"
                                    }, 
                                ]
                            },
                            address: {
                                label: "Address",
                                component: "input",
                                filed: {
                                    type: "textarea"
                                },
                                rules: [
                                    {
                                        required: true,
                                        trigger: "blur",
                                        message: "\u8BF7\u586B\u5199 Address"
                                    }, 
                                ]
                            }
                        }
                    };
                });
            };
            return {
                type: "object",
                properties: {
                    basic: {
                        type: "object",
                        title: "\u57FA\u7840\u4FE1\u606F",
                        properties: {
                            name: {
                                label: "\u5E7F\u544A\u4E3B\u540D\u79F0",
                                component: "input",
                                field: {
                                    disabled: !this.isCreate
                                },
                                rules: [
                                    {
                                        required: true,
                                        message: "\u8BF7\u8F93\u5165\u5E7F\u544A\u4E3B\u540D\u79F0",
                                        trigger: "blur"
                                    },
                                    {
                                        required: true,
                                        validator: validateUsername,
                                        trigger: "blur"
                                    }, 
                                ]
                            },
                            mws_account_type: {
                                label: "\u8D26\u53F7\u7C7B\u578B",
                                component: "radio-group",
                                rules: [
                                    {
                                        required: true
                                    }, 
                                ],
                                field: {
                                    options: mwsAccountTypeList
                                }
                            },
                            email: {
                                label: "\u90AE\u7BB1",
                                component: "input",
                                field: {
                                    disabled: this.isCreate
                                },
                                rules: [
                                    {
                                        required: true,
                                        message: "\u8BF7\u8F93\u5165\u90AE\u7BB1",
                                        trigger: "blur"
                                    },
                                    {
                                        required: true,
                                        validator: validateEmail,
                                        trigger: "blur"
                                    }, 
                                ]
                            },
                            cc_email: {
                                component: "input",
                                class: "cc-email-cell",
                                label: "\u6284\u9001\u90AE\u7BB1\u5730\u5740",
                                tail: "\u591A\u4E2A\u7528\u9017\u53F7\u9694\u5F00",
                                field: {
                                    type: "textarea",
                                    rows: 3,
                                    // placeholder: '多个用逗号隔开',
                                    listeners: {
                                        blur: function() {
                                            _this.$store.dispatch("advertiser/updateInfo", _objectSpreadProps(_objectSpread({}, _this.model), {
                                                basic: _objectSpreadProps(_objectSpread({}, _this.model.basic), {
                                                    cc_email: _this.cookCCEmail().join(",")
                                                })
                                            }));
                                        }
                                    }
                                },
                                rules: [
                                    {
                                        validator: validateCCEmail,
                                        trigger: "blur"
                                    }, 
                                ]
                            },
                            contact_num: {
                                label: "\u8054\u7CFB\u65B9\u5F0F",
                                component: "input",
                                rules: [
                                    {
                                        required: true,
                                        message: "\u8BF7\u8F93\u5165\u8054\u7CFB\u65B9\u5F0F",
                                        trigger: "blur"
                                    }, 
                                ]
                            },
                            contact: {
                                label: "\u8054\u7CFB\u4EBA",
                                component: "input"
                            },
                            organization: {
                                label: "\u516C\u53F8",
                                component: "input"
                            },
                            timezone: {
                                label: "\u65F6\u533A",
                                component: "select",
                                field: {
                                    options: this.timeZoneList,
                                    placeholder: "\u8BF7\u9009\u62E9\u65F6\u533A"
                                },
                                rules: [
                                    {
                                        required: true,
                                        message: "\u8BF7\u9009\u62E9\u65F6\u533A",
                                        trigger: "change"
                                    }, 
                                ]
                            },
                            country: {
                                label: "\u56FD\u5BB6",
                                component: "select",
                                field: {
                                    filterable: true,
                                    options: this.countryList,
                                    placeholder: "\u8BF7\u9009\u62E9\u56FD\u5BB6"
                                },
                                rules: [
                                    {
                                        required: true,
                                        message: "\u8BF7\u9009\u62E9\u56FD\u5BB6",
                                        trigger: "change"
                                    }, 
                                ]
                            },
                            company_address: {
                                label: "\u5730\u5740",
                                component: "input",
                                field: {
                                    placeholder: "\u8BF7\u8F93\u5165\u5730\u5740"
                                },
                                rules: [
                                    {
                                        required: true,
                                        message: "\u8BF7\u8F93\u5165\u5730\u5740",
                                        trigger: "blur"
                                    }, 
                                ]
                            },
                            remark: {
                                label: "\u5907\u6CE8",
                                component: "input",
                                field: {
                                    type: "textarea"
                                },
                                rules: [
                                    {
                                        message: "\u8BF7\u586B\u5199\u5907\u6CE8",
                                        trigger: "blur"
                                    }, 
                                ]
                            }
                        }
                    },
                    expand: {
                        type: "object",
                        title: "\u62D3\u5C55\u4FE1\u606F",
                        properties: {
                            bd_id: {
                                label: "BD",
                                component: "select",
                                field: {
                                    filterable: true,
                                    options: _.get(this.advertiser, "options.bd") || [],
                                    placeholder: "\u8BF7\u9009\u62E9 BD"
                                },
                                rules: [
                                    {
                                        required: true,
                                        message: "\u8BF7\u9009\u62E9 BD",
                                        trigger: "change"
                                    }, 
                                ]
                            },
                            bd_am_id: {
                                label: "BD_AM",
                                component: "select",
                                field: {
                                    filterable: true,
                                    options: _.get(this.advertiser, "options.bd_am") || [],
                                    placeholder: "\u8BF7\u9009\u62E9 BD_AM"
                                },
                                rules: [
                                    {
                                        required: true,
                                        message: "\u8BF7\u9009\u62E9 BD_AM",
                                        trigger: "change"
                                    }, 
                                ]
                            },
                            pm_adv_id: {
                                label: "PM_ADV",
                                component: "select",
                                field: {
                                    filterable: true,
                                    options: _.get(this.advertiser, "options.pm_adv") || [],
                                    placeholder: "\u8BF7\u9009\u62E9 PM_ADV"
                                },
                                rules: [
                                    {
                                        required: true,
                                        message: "\u8BF7\u9009\u62E9 PM_ADV",
                                        trigger: "change"
                                    }, 
                                ]
                            },
                            account_type: {
                                label: "Account type",
                                component: "radio-group",
                                rules: [
                                    {
                                        required: true
                                    }, 
                                ],
                                field: {
                                    disabled: true,
                                    options: accountTypeList
                                }
                            },
                            currency: {
                                label: "Settlement Currency",
                                component: "radio-group",
                                rules: [
                                    {
                                        required: true,
                                        message: "\u8BF7\u9009\u62E9 Settlement Currency"
                                    }, 
                                ],
                                field: {
                                    options: currencyList,
                                    disabled: !this.isCreate,
                                    listeners: {
                                        change: function() {
                                            // 切换币种清空合作主体
                                            _this.$store.dispatch("advertiser/updateInfo", _objectSpreadProps(_objectSpread({}, _this.model), {
                                                expand: _objectSpreadProps(_objectSpread({}, _this.model.expand), {
                                                    cooperation_entity: ""
                                                })
                                            }));
                                        }
                                    }
                                }
                            },
                            cooperation_entity: {
                                label: "Cooperation Entity",
                                component: "select",
                                field: {
                                    disabled: !this.advertiser.info.expand.currency,
                                    options: (_.get(this.advertiser, "options.adv_cooperation_entity") || []).filter(function(item) {
                                        return item.currency === _this.advertiser.info.expand.currency;
                                    }),
                                    placeholder: "\u8BF7\u9009\u62E9 Corporate entity"
                                },
                                rules: [
                                    {
                                        required: true,
                                        message: "\u8BF7\u9009\u62E9 Corporate entity",
                                        trigger: "change"
                                    }, 
                                ]
                            },
                            advance: {
                                label: "Pay in Advance",
                                component: "radio-group",
                                rules: [
                                    {
                                        trigger: "change",
                                        required: true
                                    }, 
                                ],
                                field: {
                                    options: isPrePayList
                                }
                            },
                            password: {
                                label: "Password",
                                component: "input",
                                field: {
                                    type: "password",
                                    disabled: this.isCreate && this.advertiser.exists === 2
                                },
                                rules: [
                                    {
                                        required: this.isCreate && this.advertiser.exists === 3,
                                        validator: validatePassword,
                                        trigger: "blur"
                                    }, 
                                ]
                            }
                        }
                    },
                    invoices: {
                        type: "array",
                        title: "invoice \u4FE1\u606F",
                        class: "invoice-fieldset",
                        addable: {
                            text: "\u65B0\u589E",
                            circle: false,
                            type: "primary"
                        },
                        removable: function(schema, key) {
                            var index = Number(key);
                            console.log(_this.advertiser.info.invoices[index]);
                            return {
                                text: "\u5220\u9664",
                                circle: false,
                                type: "danger",
                                // 第一个不给删除，已保存的invoice信息不能删除，readonly 不可删除
                                disabled: index === 0 || _.get(_this.advertiser, "info.invoices[".concat(index, "].readonly")) || !!_this.advertiser.info.invoices[index].id
                            };
                        },
                        minItems: 1,
                        maxItems: 20,
                        items: cookInvoiceFormItem(),
                        additionalItems: {
                            type: "object",
                            properties: {
                                name: {
                                    label: "Invoice Name",
                                    component: "input",
                                    rules: [
                                        {
                                            required: true,
                                            trigger: "blur",
                                            message: "\u8BF7\u586B\u5199 Invoice Name"
                                        },
                                        {
                                            required: true,
                                            validator: validateInvoiceName,
                                            trigger: "blur"
                                        }, 
                                    ]
                                },
                                company: {
                                    label: "Name Of Business",
                                    component: "input",
                                    rules: [
                                        {
                                            required: true,
                                            trigger: "blur",
                                            message: "\u8BF7\u586B\u5199 Name Of Business"
                                        }, 
                                    ]
                                },
                                address: {
                                    label: "Address",
                                    component: "input",
                                    filed: {
                                        type: "textarea"
                                    },
                                    rules: [
                                        {
                                            required: true,
                                            trigger: "blur",
                                            message: "\u8BF7\u586B\u5199 Address"
                                        }, 
                                    ]
                                }
                            }
                        }
                    }
                }
            };
        }
    },
    mounted: function mounted() {
        this.$store.dispatch("config/getCountryList");
        this.$store.dispatch("config/getTimeZoneList");
    },
    methods: {
        resetForm: function resetForm() {
            if (!this.$refs.form) return;
            var ref = this.$refs.form;
            ref.resetFields();
            ref.clearValidate();
        },
        updateForm: function updateForm() {
            var ref = this.$refs.form;
            ref.updateSchema();
        },
        cancel: function cancel() {
            this.$emit("cancel");
        },
        submit: function submit() {
            var form = this.$refs.form;
            var _this = this;
            form.validate(function() {
                var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(valid) {
                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                if (!valid) {
                                    _ctx.next = 22;
                                    break;
                                }
                                _ctx.prev = 1;
                                _this.$store.commit("advertiser/updateLoading", true);
                                _ctx.next = 5;
                                return _this.$store.dispatch("advertiser/updateInfo", _this.model);
                            case 5:
                                if (!_this.isCreate) {
                                    _ctx.next = 10;
                                    break;
                                }
                                _ctx.next = 8;
                                return _this.$store.dispatch("advertiser/create");
                            case 8:
                                _ctx.next = 12;
                                break;
                            case 10:
                                _ctx.next = 12;
                                return _this.$store.dispatch("advertiser/update");
                            case 12:
                                _this.$message({
                                    type: "success",
                                    message: "".concat(_this.isCreate ? "\u521B\u5EFA\u5E7F\u544A\u4E3B\u6210\u529F" : "\u66F4\u65B0\u5E7F\u544A\u4E3B\u4FE1\u606F\u6210\u529F")
                                });
                                _this.$emit("save-success");
                                _ctx.next = 19;
                                break;
                            case 16:
                                _ctx.prev = 16;
                                _ctx.t0 = _ctx["catch"](1);
                                console.log(_ctx.t0);
                            case 19:
                                _ctx.prev = 19;
                                _this.$store.commit("advertiser/updateLoading", false);
                                return _ctx.finish(19);
                            case 22:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            16,
                            19,
                            22
                        ]
                    ]);
                }));
                return function(valid) {
                    return _ref.apply(this, arguments);
                };
            }());
        },
        handleAddField: function handleAddField() {
            return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var form;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return this.$store.dispatch("advertiser/addInvoice");
                        case 2:
                            form = this.$refs.form;
                            form.updateSchema();
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, this);
            })).apply(this);
        },
        handleRemoveField: function handleRemoveField(schema, index) {
            return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var form;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return this.$store.dispatch("advertiser/removeInvoice", {
                                index: index
                            });
                        case 2:
                            form = this.$refs.form;
                            form.updateSchema();
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, this);
            })).apply(this);
        },
        cookCCEmail: function cookCCEmail() {
            return this.model.basic.cc_email.replaceAll("\uFF0C", ",").replaceAll(" ", "").split(",").filter(function(t) {
                return t !== "";
            });
        }
    }
});
